import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import Axios from 'axios';
import moment from 'moment';
import cogoToast from 'cogo-toast';

import AddTitleBar from '../titleBar/addTitleBar';
import APP_CONSTANTS from '../../config/constants';

import { DateData } from '../formikInput/date';
import { MyInput, MyTextArea } from '../formikInput/input';

//Add-Product
import AddProduct from './addProduct';

//Dropdowns
import BillingPartyDropdown from '../dropdowns/billingPartyDropdown';
import CustomerBranchDropdown from '../dropdowns/customerBranchDropdown';
import VendorVehicleDropdown from '../dropdowns/vendorVehicleDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import ConsigneeDropdown from '../dropdowns/consigneeDropdown';

//Actions 
import { createSalesOrder } from '../../redux/actions/salesOrderActions';
import { useState } from 'react';
import ConsignorDropdown from '../dropdowns/consignorDropdown';
import { LOCAL_STORAGE } from '../utils/constants';

const AddSalesOrder = (props) => {
    const { createSalesOrder } = props;
    //State
    const [branchData, setBranchData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [vehicleData, setVehicleData] = useState([]);
    const [vendorDetails, setVendorDetails] = useState({});
    const [customerGst, setCustomerGst] = useState('');
    const [customerState, setCustomerState] = useState('');
    const [customerdetails, setCustomerDetails] = useState('')
    const [consigneeDetails, setConsigneeDetails] = useState('')
    const [consignorDetails, setConsignorDetails] = useState('')
    const [branchStateMapId, setBranchStateMapId] = useState()
    const [customerbranchStateMapId, setCustomerBranchStateMapId] = useState()
    const [selectedBrannch, setSelectedBranch] = useState(null);
    const [isGstApplicable, setIsGstApplicable] = useState(false);
    const [isGstExempted, setIsGstExempted] = useState(false);
    const [msgToDisplay, setMsgToDisplay] = useState(null);
    const [branchGstNo, setBranchGstNo] = useState(null);
    const [gstChargeMechanism, setGstChargeMechanism] = useState('')

    useEffect(() => {
        cogoToast.info("Select Customer Name first!")

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))
    }, [])

    //ArrayHelper
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    //Get Data from Child Components
    const getBranchData = childData => {
        setBranchData(childData)
    };

    const getVehicleData = childData => {
        setVehicleData(childData);
    }

    const getCustomerDetails = childData => {
        setCustomerDetails(childData);
    }

    const getConsigneeData = childData => {
        setConsigneeDetails(childData)
    }

    const getConsignorData = childData => {
        setConsignorDetails(childData)
    }

    const getBranchSelected = async (childData) => {
        const branchDetails = await branchData.find(data => data.billingPartyBranchCode === childData);
        if (branchDetails) {
            setSelectedBranch(branchDetails?.isGSTExempted === 1 ? `GST Exempted - ${branchDetails.GSTExemptedReasonName}` : null);
            cBranchChange(branchDetails?.isGSTExempted);
            setIsGstExempted(branchDetails?.isGSTExempted === 1)
            setIsGstApplicable(branchDetails?.isGstApplicable === 1)
            setCustomerGst(branchDetails.billingPartyBranchGst);
            setCustomerState(branchDetails.state)
            setCustomerBranchStateMapId(branchDetails.billingPartyBranchStateId)
        }
    };

    const getBranchStateMapId = (childData, data = null) => {
        const res = data?.options?.find((item) => { return item.value === data.value });
        if (res) {
            isGSTApplicableOrNot(res.isGSTApplicable, res.gstChargeMechanism);
            setBranchGstNo(res.gstNo)
            setGstChargeMechanism(res.gstChargeMechanism)
        }
        else {
            setBranchGstNo(null)
        }
        setBranchStateMapId(childData);
    };

    const cBranchChange = (isGSTExempted = null) => {
        if (isGSTExempted === 1) {
            setMsgToDisplay('Customer Branch is GST Exempted');
            return;
        }
    };

    const isGSTApplicableOrNot = (isGSt, isRCM = null, isGSTExempted = null) => {
        if (isGSt === 0) {
            setMsgToDisplay('GST not applicable for branch');
            return;
        } else {
            // if (salesOrderDetails[0].is_gst_exempted === 1) {
            //     console.log("else - if call")
            //     setMsgToDisplay('bcd');
            //     return;
            // }
            // else
            if (isRCM === 'RCM') {
                setMsgToDisplay('Branch GST charge mechanism is RCM');
                return;
            }
            else if (isGSTExempted === 1) {
                setMsgToDisplay('Product is GST exempted');
                return;
            }
            else {
                setMsgToDisplay(null);
                return;
            }
        }
    };

    const initialValues = {
        customerName: '',
        consigneeName: '',
        consignorName: '',
        customerBranch: '',
        branch: '',
        customerGst: customerGst,
        consigneeGst: customerGst,
        customerState: customerState,
        consigneeState: customerState,
        vehicle: '',
        salesOrderDate: '',
        lrNo: '',
        lrDate: '',
        tripMemoNo: '',
        salesOrderNo: '',
        refNo: '',
        gstChargeMechanism:gstChargeMechanism,
        productDetails: [{
            productName: '',
            startDate: '',
            endDate: '',
            quantity: 1,
            rate: '',
            discount: '',
            discountType: "1",
            iGstPercent: 0,
            iGst: 0,
            cGstPercent: '',
            cGst: '',
            sGstPercent: '',
            sGst: 0,
            amount: 0,
        }],
        finalAmount: '',
        adjustmentAmount: '',
        remarks: ''
    };

    const validateSchema = yup.object().shape({
        customerName: yup.mixed().required('Customer Name is Required'),
        customerBranch: yup.mixed().required('Branch is Required'),
        branch: yup.mixed().required('Branch is Required'),
        salesOrderDate: yup.mixed().required('Sales Order Date is Required'),
        refNo: yup.mixed().optional(''),
        remarks: yup.mixed().optional(),
        productDetails: yup.array().of(
            yup.object().shape({
                productName: yup.string().required("Add a product/service"),
                quantity: yup.number("Should be a number").required("Quantity is required").min(1, "Should be more than 0"),
                rate: yup.number("Should be a number").required("Rate is required").min(1, "Should be more than 1")
                // payment: yup.number().positive().when(['checkbox', 'amountDue'], (checkbox, amountDue, schema) => {
                //     return checkbox && checkbox === true ? schema.required("Payment Amount is Required").min(1, "Payment Amount should be more than 0").max(amountDue, "Payment can't exceed Amount Due") : schema
                // })
            })
        )
    });

    const onSubmit = (values, onSubmitProps) => {
        const psLineItems = [];
        values.productDetails.map((product, index) => {
            let temp = {}
            temp.product_code = product.productCode
            temp.start_date = product.startDate
            temp.end_date = product.endDate
            temp.product_qty = product.quantity
            temp.product_price = product.rate
            temp.product_amount = product.rate * product.quantity
            temp.igst_percentage = product.iGstPercent
            temp.igst_amount = product.iGst
            temp.cgst_percentage = product.cGstPercent
            temp.cgst_amount = product.cGst
            temp.sgst_percentage = product.sGstPercent
            temp.sgst_amount = product.sGst
            temp.tds_id = 9
            temp.tds_amount = 0
            temp.pending_tds_amount = 0
            temp.no_of_days = 0
            temp.discount = product.discount
            temp.final_discount = product.discount
            temp.discount_type = product.discountType
            temp.taxable_amount = product.rate * product.quantity - product.discount
            temp.total_amount = product.amount
            psLineItems[index] = temp
        });

        const createSOData = {
            user_id: LOCAL_STORAGE.userId,
            customer_no: LOCAL_STORAGE.customerNo,
            client_code: values.customerName,
            isGSTExempted:isGstExempted ? 1 : 0,
            gstChargeMechanism: gstChargeMechanism || null,
            client_branch_code: values.customerBranch,
            consignee_code: values.consigneeName,
            consignor_code: values.consignorName,
            branch_code: values.branch,
            so_date: values.salesOrderDate ? moment(values.salesOrderDate).format('DD-MM-YYYY') : '',
            reference_number: values.refNo,
            vehicle_no: values.vehicle,
            lr_no: values.lrNo,
            lr_date: values.lrDate ? moment(values.lrDate).format('DD-MM-YYYY') : null,
            trip_memo_no: values.tripMemoNo,
            taxable_amount: psLineItems.sum("taxable_amount"),
            so_quantity: psLineItems.length,
            so_amount: values.finalAmount,
            tds_amount: 0,
            sgst_amount: psLineItems.sum("sgst_amount"),
            cgst_amount: psLineItems.sum("cgst_amount"),
            igst_amount: psLineItems.sum("igst_amount"),
            remarks: values.remarks,
            total_order_amt: values.finalAmount,
            adjustment: values.adjustmentAmount,
            gst_tax_type: 0,
            total_discount: psLineItems.sum("discount"),
            products: psLineItems,
        };

        createSalesOrder(createSOData).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });
    };

    return (
        <React.Fragment>
            <AddTitleBar title="New Sales Order" LinkName="/salesorder" />
            <div className="m-2">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}>
                    {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                        
                        <>
                            <Segment>
                                {console.log(values,'valuessss')}
                                <div className="ui form tiny">
                                    <FormUi.Group>
                                        <FormUi.Field width="2">
                                            <label className="labelName mt-2">Branch<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="5">
                                            <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" getBranchStateMapId={getBranchStateMapId} />
                                            {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Consignor Name</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={ConsignorDropdown} name="consignorName"
                                                getConsignorData={getConsignorData}
                                                branchData={branchData} />
                                            {touched.consignorName && errors.consignorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consignorName}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="2">
                                            <label className="labelName mt-2">Customer Name<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="5">
                                            <Fieldmik component={BillingPartyDropdown} name="customerName" placeholder="Customer Name" getBranchData={getBranchData} getVehicleData={getVehicleData} getCustomerDetails={getCustomerDetails} />
                                            {touched.customerName && errors.customerName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerName}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Consignee Name</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={ConsigneeDropdown} name="consigneeName"
                                                getConsigneeData={getConsigneeData}
                                                branchData={branchData} />
                                            {touched.consigneeName && errors.consigneeName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.consigneeName}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        {values.customerName ?
                                            <>
                                                <FormUi.Field width="2">
                                                    <label className="labelName mt-2">Customer Branch</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik
                                                        className="w3-text-black"
                                                        component={CustomerBranchDropdown}
                                                        name="customerBranch"
                                                        // salesOrderDetails={salesOrderDetails}
                                                        branchData={branchData}
                                                        getBranchSelected={getBranchSelected}
                                                        value={values.customerBranch}
                                                        setVendorDetails={setVendorDetails}
                                                        setBranchData={setBranchData}
                                                    />
                                                    <span style={{ color: '#006837', fontWeight: 600, marginTop: '10px' }}>{selectedBrannch}</span>
                                                    {touched.customerBranch && errors.customerBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerBranch}</strong> : ''}
                                                </FormUi.Field>
                                            </>
                                            :
                                            <FormUi.Field width="7" />
                                        }
                                        <FormUi.Field width="1" />

                                    </FormUi.Group>

                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Customer GST</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            {/* <Fieldmik readOnly name="customerGst" placeholder="GST" value={customerGst} /> */}
                                            {customerGst}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Consignee GST</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            {/* <Fieldmik readOnly name="consigneeGst" placeholder="GST" value={customerGst} /> */}
                                            {consigneeDetails ? consigneeDetails.gstNumber : ''}
                                            {/* {customerGst}  */}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Branch GST</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            {branchGstNo}
                                        </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Customer State</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            {/* <Fieldmik readOnly name="customerState" placeholder="Customer State" value={customerState} /> */}
                                            {customerState}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Consignee State</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            {/* <Fieldmik readOnly name="consigneeState" placeholder="Customer State" value={customerState} /> */}
                                            {/* {customerState} */}
                                        </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Vehicle Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={VendorVehicleDropdown} name="vehicle" placeholder="Vehicle Number" />
                                            {touched.vehicle && errors.vehicle ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicle}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Sales Order Date<span className='mandatory-star'> *</span></label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <DateData
                                                name={`salesOrderDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Date"
                                                selected={values.salesOrderDate}
                                                // minDate={new Date()}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.salesOrderDate && errors.salesOrderDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.salesOrderDate}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">LR No.</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="lrNo" placeholder="LR No." />
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">LR Date</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="3">
                                            <DateData
                                                name={`lrDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Date"
                                                value={values.salesOrderDate}
                                                // selected={values.salesOrderDate}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.lrDate && errors.lrDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.lrDate}</strong> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Trip Memo No.</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="tripMemoNo" placeholder="Trip Memo No." />
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Remarks</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={MyTextArea} name="remarks" placeholder="Remarks" />
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                    </FormUi.Group>
                                </div>
                            </Segment>
                            <Segment>
                                <div className="ui form tiny">
                                    <FormUi.Group >
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Sales Order Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik component={MyInput} name="salesOrderNo" placeholder="Sales Order Number" />
                                            {touched.salesOrderNo && errors.salesOrderNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.salesOrderNo}</strong> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="1" />
                                        <FormUi.Field width="3">
                                            <label className="labelName mt-2">Reference Number</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                            <Fieldmik name="refNo" placeholder="Reference No." />
                                        </FormUi.Field>
                                        {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}

                                    </FormUi.Group>

                                    {/* FieldArray Component */}
                                    <AddProduct masterState={branchStateMapId} vendorStateId={customerbranchStateMapId} isGstApplicable={isGstExempted ? false : true} />

                                </div>
                            </Segment>
                            <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                        </>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = state => ({
    isLoading: state.createSalesOrderData.isLoading
})


export default connect(mapStatetoProps, { createSalesOrder })(AddSalesOrder)


